// extracted by mini-css-extract-plugin
export default {"slideshowContainer":"GifImageSlider_slideshowContainer__OPwwH","slide":"GifImageSlider_slide__oqUoS","active":"GifImageSlider_active__kspBz","fade":"GifImageSlider_fade__K5tfX"};